import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ICheckControl, ICheckLayoutSetUp, ICheckPrintDateRange, ICheckPrintDetails, ICheckSetUpDetails, ICheckSignature, ICheckSignatureResponse } from '../Shared/Interfaces/ICheckWriting';
import { ICommon, IResponseModel } from '../Shared/model/CommonModel';
import { EFontName, EPrintOrientation, EPrintPart } from '../Shared/enum';
import { WordReplacePipe } from '../Shared/word-replace.pipe';
// import { WordReplacePipe } from '../Shared/word-replace.pipe';

@Injectable({
    providedIn: 'root',
})

export class CheckWritingService {
    private baseURL: string;
    printOrientation: ICommon[] = [
        { Id: EPrintOrientation['1PerPage'], Name: '1-Per Page' },
        { Id: EPrintOrientation['2PerPage'], Name: '2-Per Page' },
        { Id: EPrintOrientation['3PerPage'], Name: '3-Per Page' },
    ];
    checkPrintPositions = [
        { Id: 1, Name: EPrintPart[EPrintPart.Top], Visible: true },
        { Id: 2, Name: EPrintPart[EPrintPart.Middle], Visible: true },
        { Id: 3, Name: EPrintPart[EPrintPart.Bottom], Visible: true },
    ];
    fieldLineSize = [
        { Id: 1, Name: '1' },
        { Id: 2, Name: '2' },
        { Id: 3, Name: '3' },
        { Id: 4, Name: '4' }
    ];

    checkFieldControlsList: ICheckControl[] = [
        { ControlName: 'txtAmountinWords', ControlCaption: 'Amount in Words', DefaultValue: 'One hundred and twenty 35/100', DefaultXPosition: 180, DefaultYPosition: 210, DefaultLineLength: 786, IsLine: false, IsVisible: true, FontNameId: EFontName.Arial, Width: 800, FontStyleId: null, FontSize: 12, LineSize: null },
        { ControlName: 'lnAmountLine', ControlCaption: 'Amount in Words Line', DefaultValue: '', DefaultXPosition: 100, DefaultYPosition: 240, DefaultLineLength: 786, IsLine: true, IsVisible: true, FontNameId: EFontName.Arial, Width: 100, FontStyleId: null, FontSize: 12, LineSize: 1 },
        { ControlName: 'txtCompanyName', ControlCaption: 'Market Name', DefaultValue: 'ABC Antiquemall', DefaultXPosition: 100, DefaultYPosition: 80, DefaultLineLength: null, IsLine: false, IsVisible: true, FontNameId: EFontName.Arial, Width: 100, FontStyleId: null, FontSize: 12, LineSize: null },
        { ControlName: 'txtBankName', ControlCaption: 'Bank Information', DefaultValue: 'Bank Information', DefaultXPosition: 660, DefaultYPosition: 80, DefaultLineLength: null, IsLine: false, IsVisible: true, FontNameId: EFontName.Arial, Width: 100, FontStyleId: null, FontSize: 12, LineSize: null },
        { ControlName: 'txtBankTransitCode', ControlCaption: 'Bank Transit Code', DefaultValue: 'Bank Transit Code', DefaultXPosition: 930, DefaultYPosition: 120, DefaultLineLength: null, IsLine: false, IsVisible: true, FontNameId: EFontName.Arial, Width: 120, FontStyleId: null, FontSize: 12, LineSize: null },
        { ControlName: 'txtCheckAmount', ControlCaption: 'Check Amount', DefaultValue: '120.35', DefaultXPosition: 950, DefaultYPosition: 140, DefaultLineLength: null, IsLine: false, IsVisible: true, FontNameId: EFontName.Arial, Width: 100, FontStyleId: null, FontSize: 12, LineSize: null },
        { ControlName: 'txtCheckDate', ControlCaption: 'Check Date', DefaultValue: 'MM/dd/yyyy', DefaultXPosition: 1000, DefaultYPosition: 80, DefaultLineLength: null, IsLine: false, IsVisible: true, FontNameId: EFontName.Arial, Width: 100, FontStyleId: null, FontSize: 12, LineSize: null },
        { ControlName: 'txtCheckNumber', ControlCaption: 'Check Number', DefaultValue: '00', DefaultXPosition: 1050, DefaultYPosition: 40, DefaultLineLength: null, IsLine: false, IsVisible: true, FontNameId: EFontName.Arial, Width: 140, FontStyleId: null, FontSize: 12, LineSize: null },
        { ControlName: 'txtCheckDateText', ControlCaption: 'Check Date Text', DefaultValue: 'Date', DefaultXPosition: 930, DefaultYPosition: 80, DefaultLineLength: null, IsLine: false, IsVisible: true, FontNameId: EFontName.Arial, Width: 50, FontStyleId: null, FontSize: 12, LineSize: null },
        { ControlName: 'txtCheckNoText', ControlCaption: 'Check Number Text', DefaultValue: 'No.', DefaultXPosition: 930, DefaultYPosition: 40, DefaultLineLength: null, IsLine: false, IsVisible: true, FontNameId: EFontName.Arial, Width: 50, FontStyleId: null, FontSize: 12, LineSize: null },
        { ControlName: 'txtDollar', ControlCaption: 'Dollar', DefaultValue: '$', DefaultXPosition: 930, DefaultYPosition: 140, DefaultLineLength: null, IsLine: false, IsVisible: true, FontNameId: EFontName.Arial, Width: 50, FontStyleId: null, FontSize: 12, LineSize: null },
        { ControlName: 'txtMemo', ControlCaption: 'Memo', DefaultValue: 'Check Layout Setting', DefaultXPosition: 180, DefaultYPosition: 340, DefaultLineLength: null, IsLine: false, IsVisible: true, FontNameId: EFontName.Arial, Width: 210, FontStyleId: null, FontSize: 12, LineSize: null },
        { ControlName: 'lnMemoLine', ControlCaption: 'Memo Line', DefaultValue: '', DefaultXPosition: 180, DefaultYPosition: 380, DefaultLineLength: 288, IsLine: true, IsVisible: true, FontNameId: EFontName.Arial, Width: 100, FontStyleId: null, FontSize: 12, LineSize: 1 },
        { ControlName: 'txtMemoText', ControlCaption: 'Memo Text', DefaultValue: 'Memo :', DefaultXPosition: 100, DefaultYPosition: 350, DefaultLineLength: null, IsLine: false, IsVisible: true, FontNameId: EFontName.Arial, Width: 50, FontStyleId: null, FontSize: 12, LineSize: null },
        { ControlName: 'txtMICR', ControlCaption: 'MICR Details', DefaultValue: 'C000101C A084302698A 160 584 9 C', DefaultXPosition: 400, DefaultYPosition: 320, DefaultLineLength: null, IsLine: false, IsVisible: true, FontNameId: EFontName.Arial, Width: 280, FontStyleId: null, FontSize: 12, LineSize: null },
        { ControlName: 'txtOrderOfText', ControlCaption: 'Order of Text', DefaultValue: 'Order Of', DefaultXPosition: 100, DefaultYPosition: 180, DefaultLineLength: null, IsLine: false, IsVisible: true, FontNameId: EFontName.Arial, Width: 100, FontStyleId: null, FontSize: 12, LineSize: null },
        { ControlName: 'lnPayto', ControlCaption: 'Pay To Line', DefaultValue: '', DefaultXPosition: 160, DefaultYPosition: 180, DefaultLineLength: 600, IsLine: true, IsVisible: true, FontNameId: EFontName.Arial, Width: 100, FontStyleId: null, FontSize: 12, LineSize: 1 },
        { ControlName: 'txtPaytotheText', ControlCaption: 'Pay To the Text', DefaultValue: 'Pay To The', DefaultXPosition: 100, DefaultYPosition: 150, DefaultLineLength: null, IsLine: false, IsVisible: true, FontNameId: EFontName.Arial, Width: 100, FontStyleId: null, FontSize: 12, LineSize: null },
        { ControlName: 'lnSignature', ControlCaption: 'Signature Line', DefaultValue: '', DefaultXPosition: 618, DefaultYPosition: 300, DefaultLineLength: 388, IsLine: true, IsVisible: true, FontNameId: EFontName.Arial, Width: 100, FontStyleId: null, FontSize: 12, LineSize: 1 },
        { ControlName: 'txtDollarsText', ControlCaption: 'Text Dollars', DefaultValue: 'Dollars', DefaultXPosition: 950, DefaultYPosition: 240, DefaultLineLength: null, IsLine: false, IsVisible: true, FontNameId: EFontName.Arial, Width: 100, FontStyleId: null, FontSize: 12, LineSize: null },
        { ControlName: 'txtVendorName', ControlCaption: 'Vendor Name', DefaultValue: 'Mike Kane', DefaultXPosition: 200, DefaultYPosition: 155, DefaultLineLength: null, IsLine: false, IsVisible: true, FontNameId: EFontName.Arial, Width: 300, FontStyleId: null, FontSize: 12, LineSize: null },
        { ControlName: 'txtVendorAddress', ControlCaption: 'Vendor Address', DefaultValue: 'Vendor Address', DefaultXPosition: 174, DefaultYPosition: 258, DefaultLineLength: null, IsLine: false, IsVisible: true, FontNameId: EFontName.Arial, Width: 100, FontStyleId: null, FontSize: 12, LineSize: null },
        { ControlName: 'txtVendorID', ControlCaption: 'Vendor ID', DefaultValue: 'A004', DefaultXPosition: 140, DefaultYPosition: 300, DefaultLineLength: null, IsLine: false, IsVisible: true, FontNameId: EFontName.Arial, Width: 100, FontStyleId: null, FontSize: 12, LineSize: null },
        { ControlName: 'imgSignature', ControlCaption: 'Signature Image', DefaultValue: '', DefaultXPosition: 618, DefaultYPosition: 295, DefaultLineLength: null, IsLine: false, IsVisible: true, FontNameId: null, Width: 180, FontStyleId: null, FontSize: null, LineSize: null },
    ];

    constructor(private http: HttpClient,
        private wordReplacePipe: WordReplacePipe
    ) {
        this.baseURL = environment.apiBaseUrl;
        this.checkFieldControlsList.forEach(field => {
            field.ControlCaption = wordReplacePipe.transform(field.ControlCaption);
        });
    }

    getAmountInLineWithSymbol(value: string, lineLength: number, fontSize: number): string {
        const pixelDivisor = (fontSize >= 32) ? 20 : ((fontSize >= 28) ? 16 : ((fontSize >= 24) ? 14 : ((fontSize >= 18) ? 10 : ((fontSize >= 16) ? 10 : (fontSize == 14) ? 7 : ((fontSize >= 10) ? 6 : (fontSize >= 6 ? 5 : 4))))));
        const contentLength = Math.floor((lineLength / pixelDivisor) - (value.length / 1.5));
        const reqStars = (contentLength && contentLength) > 0 ? '*'.repeat(contentLength) : '';
        return value.concat(reqStars);
    }

    getCheckSetUpDetails(): Observable<ICheckSetUpDetails> {
        return this.http.get<any>(`${this.baseURL}/CheckWriting/GetCheckSetUpDetails`, { observe: 'response' }).pipe(
            map(res => {
                const result = res.body as ICheckSetUpDetails;
                return result;
            }),
            catchError(this.handleError));
    }

    UpdateCheckPrints(model: ICheckPrintDetails[]): Observable<IResponseModel> {
        return this.http.post<any>(`${this.baseURL}/CheckWriting/UpdateCheckPrints`, model, { observe: 'response' }
        ).pipe(
            map((res: HttpResponse<IResponseModel>) => res.body),
            catchError(this.handleError)
        );
    }

    saveCheckSetUpDetails(model: ICheckSetUpDetails): Observable<IResponseModel> {
        return this.http.post<any>(`${this.baseURL}/CheckWriting/SaveCheckSetUpDetails`, model, { observe: 'response' }
        ).pipe(
            map((res: HttpResponse<IResponseModel>) => res.body),
            catchError(this.handleError)
        );
    }

    getCheckLayoutSetUpList(): Observable<ICheckLayoutSetUp[]> {
        return this.http.get<any>(`${this.baseURL}/CheckWriting/GetCheckLayoutSetUpList`, { observe: 'response' }).pipe(
            map(res => {
                const result = res.body as ICheckLayoutSetUp[];
                return result;
            }),
            catchError(this.handleError));
    }

    saveCheckLayouts(model: ICheckLayoutSetUp[]): Observable<IResponseModel> {
        return this.http.post<any>(`${this.baseURL}/CheckWriting/SaveCheckLayouts`, model, { observe: 'response' }
        ).pipe(
            map((res: HttpResponse<IResponseModel>) => res.body),
            catchError(this.handleError)
        );
    }

    getCheckPrintDateRange(): Observable<ICheckPrintDateRange[]> {
        return this.http.get<any>(`${this.baseURL}/CheckWriting/GetCheckPrintDateRange`, { observe: 'response' }).pipe(
            map(res => {
                const result = res.body as ICheckPrintDateRange[];
                return result;
            }),
            catchError(this.handleError));
    }

    getCheckPrintDetailsList(payOutDate, fromDate, toDate, machineName, userName): Observable<ICheckPrintDetails[]> {
        return this.http.get<any>(`${this.baseURL}/CheckWriting/GetCheckPrintDetailsList?payOutDate=${payOutDate}&fromDate=${fromDate}&toDate=${toDate}&machineName=${machineName}&userName=${userName}`, { observe: 'response' }).pipe(
            map(res => {
                const result = res.body as ICheckPrintDetails[];
                return result;
            }),
            catchError(this.handleError));
    }

    getCheckSummaryData(payload: any): Observable<any[]> {
        return this.http.post<any>(
            `${this.baseURL}/CheckWriting/GetCheckSummaryData`,
            payload,
            { observe: 'response' }
        ).pipe(
            map((res: HttpResponse<any[]>) => res.body),
            catchError(this.handleError)
        );
    }

    saveCheckSignature(payload: ICheckSignature): Observable<ICheckSignatureResponse> {
        return this.http.post<ICheckSignatureResponse>(
            `${this.baseURL}/CheckWriting/SaveCheckSignature`,
            payload,
            { observe: 'response' }
        ).pipe(
            map((res: HttpResponse<ICheckSignatureResponse>) => res.body),
            catchError(this.handleError)
        );
    }

    // Common error handler
    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
            return throwError(() => error.error.message);
        }
        return throwError(() => error.message || 'Server error');
    }
}
